import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { UserDataListener } from '../../interface/user-data-listener';
import { UserDataModel } from '../../interface/user-data-model';

@Component({
    selector: 'app-user-portability-data',
    templateUrl: './user-portability-data.component.html',
    styleUrls: ['./user-portability-data.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class UserPortabilityDataComponent implements OnInit, UserDataListener {
    @Input() listener: UserDataListener;

    public userData = new UserDataModel();

    constructor(private modalService: NgbModal) {
    }

    ngOnInit(): void {
    }

    open(content) {
        this.modalService.open(content, {size: 'lg', centered: true});
    }

    // UserDataListener
    onSuccessfulValidation(userData: UserDataModel) {
        this.userData = userData;
        this.listener.onSuccessfulValidation(this.userData);
        this.modalService.dismissAll();
    }

}
